<script setup>
import { inject, ref } from 'vue'
import { useGlobalStore } from 'src/composables/useGlobalStore'
import { useMeta } from 'quasar'
import B2CContactPopup from 'components/home/B2CContactPopup.vue'
import AboutUsTeam from 'components/aboutUs/AboutUsTeam.vue'
import AboutUsContact from 'components/aboutUs/AboutUsContact.vue'
import AboutUsGoals from 'components/aboutUs/AboutUsGoals.vue'
import AboutUsBlue from 'components/aboutUs/AboutUsBlue.vue'
import AboutUsExp from 'components/aboutUs/AboutUsExp.vue'

const { isBrowser, globalConfiguration } = useGlobalStore()
const { global } = inject('Shared')

if (globalConfiguration.value && globalConfiguration.value.pages && globalConfiguration.value.pages.aboutUs) {
  useMeta({
    title: globalConfiguration.value.pages.aboutUs.title,
    meta: {
      description: { name: 'description', content: globalConfiguration.value.pages.aboutUs.description },
      keywords: { name: 'keywords', content: globalConfiguration.value.pages.aboutUs.keyword },
      canonical: { rel: 'canonical', href: 'https://raumpioniere.ch/about-us' },
      'og:title': { property: 'og:title', content: globalConfiguration.value.pages.aboutUs.ogTitle ? globalConfiguration.value.pages.aboutUs.ogTitle : globalConfiguration.value.pages.aboutUs.title },
      'og:image': { property: 'og:image', content: globalConfiguration.value.pages.aboutUs.ogImage ? globalConfiguration.value.pages.aboutUs.ogImage : 'https://raumpioniere.ch/icons/favicon-128x128.png' },
      'og:url': { property: 'og:url', content: 'https://raumpioniere.ch/about-us' },
      'og:description': { property: 'og:description', content: globalConfiguration.value.pages.aboutUs.ogDescription ? globalConfiguration.value.pages.aboutUs.ogDescription : globalConfiguration.value.pages.aboutUs.description },
      'og:type': { property: 'og:type', content: globalConfiguration.value.pages.aboutUs.ogType ? globalConfiguration.value.pages.aboutUs.ogType : 'About Us' },
      'og:locale': { property: 'og:locale', content: 'de_CH' }
    }
  })
}
const contactVisible = ref(false)
</script>

<template lang="pug">
.us--container
  b2-c-contact-popup(v-model:visible="contactVisible" :always="true")
  .routerPageSize
    about-us-exp
  about-us-blue
  .routerPageSize
    about-us-goals
    about-us-team
    about-us-contact
</template>

<style lang="sass">
</style>
